export default __webpack_public_path__ + "static/media/classic-car.8867153a.png";